import { defineStore } from "pinia";
import { auth } from "@/Services/ApiServices";

export const useUserSettingsStore = defineStore("user", {
    state: () => ({
        userName: "",
        uid: "", // keep for now
        accessToken: null,
        expiresAt: 0,
        jwtLifetimeMinutes: null,
    }),

    getters: {
        isAuthed: (s) =>
            !!s.accessToken &&
            (s.expiresAt === 0 || s.expiresAt > Date.now()),
        secondsLeft: (s) =>
            Math.max(0, Math.floor((s.expiresAt - Date.now()) / 1000)),
    },

    actions: {
        async loginWithPassword({ userName, password }) {
            // your auth.login() now returns { access_token, user_id, name }
            const { access_token, user_id, name } = await auth.login(
                userName,
                password
            );

            this.userName = name || userName;
            this.uid = String(user_id || "");
            this.accessToken = access_token;

            // Decode exp + iat from JWT if present
            try {
                const [, payload] = access_token.split(".");
                const { exp, iat } = JSON.parse(
                    atob(payload.replace(/-/g, "+").replace(/_/g, "/"))
                );

                this.expiresAt = exp ? exp * 1000 : 0;

                if (exp && iat) {
                    // difference in seconds → min
                    const lifetimeSec = exp - iat;
                    this.jwtLifetimeMinutes = Math.round(lifetimeSec / 60);
                } else {
                    this.jwtLifetimeMinutes = null;
                }
            } catch {
                this.expiresAt = 0;
                this.jwtLifetimeMinutes = null;
            }

            return true;
        },

        updateUid(v) {
            this.uid = v;
        },

        updateUserName(v) {
            this.userName = v;
        },

        logout() {
            this.accessToken = null;
            this.expiresAt = 0;
            this.userName = "";
            this.uid = "";
            this.jwtLifetimeMinutes = null;
        },
    },

    persist: {
        key: "tzapp:user:v3", // bump key to clear old OAuth data
        paths: ["userName", "uid", "accessToken", "expiresAt", "jwtLifetimeMinutes"],
        storage: localStorage,
    },
});
